import { $get, $post } from '@/utils/axios'

const mall = {
    //品类接口
    getCategoryList(params) {
        return $get(`/ysj/api/category/categoryList/${params.channelCode}`, params, 'MALL')
    },
    //所有商品列表-带关键字搜索
    getAllProduct(params) {
        return $post(`/ysj/api/product/query`, params, 'MALL')
    },
    //商品-分类列表
    getProductCategoryList(params) {
        return $post(`/ysj/api/product/productList`, params, 'MALL')
    },
    //商品详情
    getProductDetail(params) {
        return $get(`/ysj/api/product/productDetail/${params.id}`, params, 'MALL')
    },
    //热门商品
    getHotProduct(params) {
        return $post(`/ysj/api/product/homeProductList`, params, 'MALL')
    },
}
export default mall